import { useAuth } from "react-oidc-context";
import { Button } from "../f7";

export function SignIn() {
  const auth = useAuth();
  return (
    <div className="flex min-h-full items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-md border border-slate-950/10 dark:border-white/10 bg-white dark:bg-slate-900 p-6 text-center shadow-lg">
        <h1 className="text-lg font-semibold">Foodics AI Admin</h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Internal console. Sign in with your Foodics account.
        </p>
        <Button onClick={() => void auth.signinRedirect()} className="mt-5 w-full">
          Sign in
        </Button>
        {auth.error && <p className="mt-3 text-sm text-red-600 dark:text-red-400">{auth.error.message}</p>}
      </div>
    </div>
  );
}
